import React from 'react';
import ErrorBoundary from '../error-boundary';

const ComponentWrapper = ({children, ...props}) => <>
  {React.Children.map(children, child => <ErrorBoundary>
      {React.cloneElement(child, props)}
  </ErrorBoundary>)}
</>;

export default ComponentWrapper;